import StageBadge from './StageBadge';

export default StageBadge;
